// extracted by mini-css-extract-plugin
export default {"container":"login_container__oNMvT","textSection":"login_textSection__aJb5f"};